import {IPublishNews} from "./news/PublishNews/PublishNewsForm";

interface ITag {
    id: number;
    name: string;
}

export interface IFormAdapted {
    name: string;
    description: string;
    source_link: string;
    dzen_link: string;
    tg_link: string;
    image: string;
    create_date: Date;
    tags_id: number[];
}

export function formAdapter(formState: IPublishNews, availableTags: ITag[]): IFormAdapted {
    const selectedTags = Object.keys(formState.tags_id)
        .filter((tagId) => formState.tags_id[tagId])
        .map((tagId) => Number(tagId));
        console.log(formState.tags_id)


    return {
        name: formState.name,
        description: formState.description,
        source_link: formState.source_link,
        dzen_link: formState.dzen_link,
        tg_link: formState.tg_link,
        image: formState.image?.[0]?.name || "",
        create_date: formState.create_date,
        tags_id: selectedTags,
    };
}


export function getYearMonthDayFormat(value: Date | undefined):string{
    if(value){
        return value.getFullYear() +
            "-" +
            (value.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            value.getDate().toString().padStart(2, "0")
    } else {
        return ''
    }
}